import { render, staticRenderFns } from "./OptionComp.vue?vue&type=template&id=512ed11a&scoped=true&"
import script from "./OptionComp.vue?vue&type=script&lang=js&"
export * from "./OptionComp.vue?vue&type=script&lang=js&"
import style0 from "./OptionComp.vue?vue&type=style&index=0&id=512ed11a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512ed11a",
  null
  
)

export default component.exports